import { BringzzButton } from '@bringzz/components';
import React from 'react';

const FilterButtons = ({ activeFilter, onFilterChange }) => {
    const filters = [
        { id: 'all', label: 'All' },
        { id: 'orders', label: 'Orders' },
        { id: 'chats', label: 'Chats' },
        { id: 'others', label: 'Others' }
    ];

    return (
        <div className="flex gap-2 mb-4 overflow-x-auto pb-2">
            {filters.map((filter) => (
                <BringzzButton
                    key={filter.id}
                    size='sm'
                    onClick={() => onFilterChange(filter.id)}
                    className={`px-4 py-1 rounded-full whitespace-nowrap transition-all text-xs ${
                        activeFilter === filter.id
                            ? 'bg-magic-lilac text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                >
                    {filter.label}
                </BringzzButton>
            ))}
        </div>
    );
};

export default FilterButtons;
